import React from "react";
import LoaderSimple from "../general/loader";
import { getInitials } from "../../libs/utils";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";

const ClientUsersRow = ({users}) => {

  const usersList = useSelector(state => state.usersList);
  const isGettingUsers = usersList.isGettingUsers;

  const completeUsers = users.map(user => {
    return {
      ...user,
      completeName: `${user.firstName} ${user.lastName}`
					 };
  });

  return (
    <>
      { !isGettingUsers && completeUsers.length > 0 ? (
        completeUsers.map((user, index) => {
          return (
            <div key={`clientUsersRowContainer_${index}`} className="clientUsersRowContainer">
              <div className="clientUsersInitialsContainer">
                <div className="clientUsersInitials">
                  <span className="clientUsersInitialsSpan">{getInitials(user.completeName)}</span>
                </div>
              </div>
              {user.loggedIn && <div className="clientUsersActiveIndicator"></div>}
              <div className="clientUsersCompleteNameContainer">
                <span className="clientUsersCompleteName">{user.completeName}</span>
              </div>
            </div>
          );
        })
      )
        : isGettingUsers ?	(<LoaderSimple />)
          : !isGettingUsers && completeUsers.length === 0 ?
            <div className="noUsersContainer">
              <FontAwesomeIcon
                icon={["far", "user"]}
                style={{ color: "rgb(228, 234, 240)", fontSize: "100px", margin: "0 auto"}}
              />
              <span className="noUsersMessage"> <FormattedMessage id="dashboard.clientsSection.noUsersMessage" /> </span>
            </div>
            : null
      }
    </>
  );
};

export default ClientUsersRow;